import * as React from "react";
import { motion } from "framer-motion";
import { useRouter } from "next/router";

type MenuItemProps = {
  menuItem: Readonly<{
    key: string;
    label: string;
    path: string;
    icon?: React.ReactNode;
  }>;
  toggle: () => void;
  isOpen: boolean;
};

const variants = {
  open: {
    y: 0,
    opacity: 1,
    zIndex: 191,
    display: 'flex',
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    zIndex: -1,
    transition: {
      y: { stiffness: 1000 },
    },
    pointerEvent: 'none',
    transitionEnd: {
      display: 'none'
    }
  }
};

export const MenuItem = ({ menuItem, toggle, isOpen }: MenuItemProps) => {
  const router = useRouter();
  const onMenuItemClick = () => {
    if (isOpen) {
      router.push(menuItem.path);
      toggle();
    }
  };
  return (
    <motion.li
      variants={variants}
      onClick={onMenuItemClick}
      whileTap={{ scale: 0.95 }}
      className="mobile-menu-item"
      style={{ alignItems: 'center', cursor: 'pointer', display: 'flex', marginBottom: 20 }}
    >
      {menuItem.icon && <span className="icon-placeholder" style={{ marginRight: 16 }}>{menuItem.icon}</span>}
      <span className="text-placeholder">{menuItem.label}</span>
    </motion.li>
  );
};
